export type TableRow = Record<string, string>;

type TableProps = {
  data: TableRow[];
  className?: string;
  columnSpans?: Record<string, number>;
};

const Table = ({ data, className = "", columnSpans = {} }: TableProps) => {
  if (!data || data.length === 0) return null;

  const columns = Object.keys(data[0]);

  return (
    <div className={className}>
      {/* Header */}
      <div className="flex w-full text-[14px] font-medium text-white divide-x sm:divide-x-2 divide-white md:text-lg lg:text-xl bg-tomato-200 rounded-t-md md:rounded-t-lg">
        {columns.map((column, index) => {
          const span = columnSpans[column] || 1;

          return (
            <span
              style={{ flex: span }}
              key={index}
              className={`px-2 py-3 sm:px-4`}
            >
              {column}
            </span>
          );
        })}
      </div>

      {/* Body */}
      <div className="border border-[#62636C]/40 divide-y sm:divide-y-2 divide-[#62636C]/40">
        {data.map((row, rowIndex) => (
          <article
            key={rowIndex}
            className="flex text-[#62636C] divide-x sm:divide-x-2 divide-[#62636C]/40 text-[14px] md:text-base lg:text-lg"
          >
            {columns.map((column, colIndex) => {
              const span = columnSpans[column] || 1;

              return (
                <span
                  key={colIndex}
                  style={{ flex: span }}
                  className={`px-2 py-2 sm:px-4`}
                >
                  {row[column]}
                </span>
              );
            })}
          </article>
        ))}
      </div>
    </div>
  );
};

export default Table;
